import React from "react";
import styles from "./ModalContent.module.css";

const GOOGLE_INPUT_TOOLS_VIDEO_ID = "GZ7JAnSgtgQ";

export const TypingHelpContent = () => (
  <div className={styles.modalBody}>
    <div className={styles.modalHeader}>
      <h2>Hindi Typing Help</h2>
    </div>

    <div className={styles.modalContent}>
      <div className={styles.section}>
        <h4>🎥 Video Tutorial</h4>
        <div className={styles.videoContainer}>
          <iframe
            width="100%"
            height="400"
            src={`https://www.youtube.com/embed/${GOOGLE_INPUT_TOOLS_VIDEO_ID}`}
            title="Google Input Tools Installation Guide"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            style={{
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          ></iframe>
          <div className={styles.videoCaption}>
            <p>
              <strong>Watch the complete installation guide above</strong>
            </p>
            <p>
              For more tutorials, visit our{" "}
              <a
                href="https://youtube.com/@jigyasa-ai-hindi"
                target="_blank"
                rel="noopener noreferrer"
              >
                YouTube channel
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className={styles.section}>
        <h4>🔥 Installation for Windows</h4>
        <ol className={styles.stepList}>
          <li>
            <strong>Go to:</strong>{" "}
            <a
              href="https://www.google.com/inputtools/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Input Tools for Windows
            </a>
          </li>
          <li>
            <strong>Click on :</strong> "Try it out" button
          </li>
          <li>
            <strong>Click on:</strong> "Install the Chrome extension" button.
          </li>
          <li>
            <strong>Click on:</strong> "Add to Chrome" button.
          </li>
          <li>
            <strong>Add Extension:</strong> A popup window appears which says
            "It can Read and change all your data on all websites". Click "Add
            extension" button on this popup.
          </li>
          <li>
            <strong>Manage Extension:</strong> Click on Manage
            Extension/Extensions icon on chrome bar.
          </li>
          <li>
            <strong>Pin it:</strong> Look for Google Input Tools and pin it.
          </li>
          <li>
            <strong>Extension options:</strong> Click on pinned Google input
            tools and select "Extension options".
          </li>
          <li>
            <strong>Set Hindi language:</strong> Select Hindi from all
            available languages and either double click it to send it to
            right box or click on arrow to send it to right box.
          </li>
          <li>
            <strong>That's it:</strong> Now Hindi language denoted as "अ" will
            appear when you click your pinned google input tool.
          </li>
          <li>
            <strong>Use it:</strong> Whenever you want to switch to hindi
            writing, click on pinned google input tools and enable icon "अ".
            Disbale this when you want to switch back to English.
          </li>
          <li>
            <strong>
              Check the video given above for visual guidance.
            </strong>
          </li>
        </ol>
      </div>

      <div className={styles.section}>
        <h4>🎈 Installation for Mac</h4>
        <ol className={styles.stepList}>
          <li>
            <strong>Process is nearly similar on Mac</strong>
          </li>
        </ol>
      </div>

      <div className={styles.section}>
        <h4>🎯 Using in Jigyasa AI</h4>
        <ol className={styles.stepList}>
          <li>
            <strong>Open Writing Module:</strong> Go to Jigyasa AI Writing
            Comprehension
          </li>
          <li>
            <strong>Click in Answer Box:</strong> Click in any answer text box
          </li>
          <li>
            <strong>Switch to Hindi:</strong> by enabling/clicking on Google
            Input tool chrome extension.
          </li>
          <li>
            <strong>Type Your Answer:</strong> Type in English letters, they
            will convert to Hindi automatically
            <ul className={styles.subList}>
              <li>Example: Type "main" → मैं</li>
              <li>Example: Type "padhata hun" → पढ़ता हूँ</li>
            </ul>
          </li>
          <li>
            <strong>Submit:</strong> Submit your answers normally - the system
            handles Hindi text perfectly!
          </li>
        </ol>
      </div>
    </div>
  </div>
);
